import React from "react";

export default function TermsPage() {
  return (
    <div className="page-legal">
      <h1>Terms of Service</h1>
      <p>
        These Terms of Service (“Terms”) govern your use of the Nia COACH Portal (“Nia COACH”),
        developed by xX Developments (PTY) Ltd (“xX Developments”, “we”, “us”, “our”).
        By using Nia COACH, you agree to these Terms.
      </p>
      <h2>1. Eligibility</h2>
      <p>
        You must be at least 16 years old to use Nia COACH. By using Nia COACH, you confirm that you
        meet this requirement and that you are legally capable of entering into these Terms.
      </p>
      <h2>2. Nature of Service</h2>
      <p>
        Nia COACH provides coaching and self‑development guidance. Nia COACH does not provide medical,
        psychological, or legal advice, and is not a substitute for professional care. If
        you are in crisis or need urgent help, contact local emergency services.
      </p>
      <h2>3. Accounts and Security</h2>
      <p>
        You are responsible for maintaining the confidentiality of your account credentials
        and for all activity under your account. Notify us immediately of any unauthorized use.
      </p>
      <h2>4. Acceptable Use</h2>
      <p>
        You agree not to misuse Nia COACH, including attempting to access systems or data you are
        not authorized to access, disrupting service availability, or using Nia COACH for unlawful
        activities.
      </p>
      <h2>5. Content and Data</h2>
      <p>
        You retain ownership of your content. You grant xX Developments a limited license
        to process your content solely to provide and improve Nia COACH. See our Privacy Policy
        for details on data handling.
      </p>
      <h2>6. Intellectual Property</h2>
      <p>
        Nia COACH and its content, trademarks, and branding are owned by xX Developments or its
        licensors. You may not copy, modify, or distribute Nia COACH without permission.
      </p>
      <h2>7. Disclaimers</h2>
      <p>
        Nia COACH is provided “as is” without warranties of any kind. We do not guarantee that
        Nia COACH will be uninterrupted, error‑free, or suitable for a particular purpose.
      </p>
      <h2>8. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, xX Developments is not liable for any indirect,
        incidental, or consequential damages arising from your use of Nia COACH.
      </p>
      <h2>9. Termination</h2>
      <p>
        We may suspend or terminate access to Nia COACH if you violate these Terms or if required
        by law or security considerations.
      </p>
      <h2>10. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the Republic of South Africa.
      </p>
      <h2>11. Contact</h2>
      <p>
        For questions about these Terms, contact xX Developments (PTY) Ltd.
      </p>
    </div>
  );
}
